export function AppLogoDark({
  height,
  width,
}: {
  height: number;
  width: number;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1391_10476)">
        <rect x="0.861572" width="36" height="36" rx="8.61539" fill="#F1F5F9" />
        <rect x="0.861572" width="36" height="36" fill="white" />
        <path
          d="M18.9281 14.8299H18.2149C17.9178 13.1013 17.0263 11.8495 15.2137 11.8495C12.896 11.8495 11.6479 14.1444 11.6479 17.9891C11.6479 21.5954 13.1931 23.5923 16.0755 23.5923C17.2938 23.5923 18.6012 22.9068 19.1361 22.1915L19.4927 22.4895C19.2252 23.0558 19.0172 23.6519 18.839 24.248C17.9772 24.9036 16.6401 25.5295 14.8274 25.5295C9.03303 25.5295 7.10156 21.5954 7.10156 17.9593C7.10156 13.5782 10.1919 10.3295 14.9463 10.3295C17.1452 10.3295 18.6309 10.8958 20.0573 11.7303C19.5818 12.5052 19.1361 13.7868 18.9281 14.8299Z"
          fill="#1E293B"
        />
        <path
          d="M25.6858 10.7299L25.5967 14.3704L25.6561 14.4301C26.6955 11.6848 28.1507 10.4315 30.1405 10.4315C30.3187 10.4315 30.4672 10.4614 30.6157 10.4614C30.4969 11.0582 30.4375 11.6848 30.4375 12.6099C30.4375 13.2067 30.4375 13.893 30.4672 14.5793L30.1999 14.818C29.8138 14.5793 29.309 14.4003 28.6853 14.4003C26.9034 14.4003 25.8046 15.7729 25.8046 17.3544V18.548C25.8046 20.965 25.864 23.0837 26.0422 25.1725C25.5373 25.1128 24.7355 25.0233 23.8148 25.0233C22.8942 25.0233 22.1221 25.1128 21.5875 25.1725C21.7657 23.0837 21.8251 20.965 21.8251 18.548V17.3544C21.8251 14.9374 21.7657 12.8187 21.5875 10.7299C22.2705 10.7896 22.9536 10.8791 23.6366 10.8791C24.3197 10.8791 25.0028 10.7896 25.6858 10.7299Z"
          fill="#1E293B"
        />
        <path
          d="M21.8005 16.8562C21.8766 19.9014 19.1849 22.3086 17.9291 23.1181C16.369 24.236 18.5115 24.5141 18.7663 24.3131C22.7238 21.1907 21.7344 20.9594 23.3326 18.0683C22.8125 16.5649 21.7396 14.4199 21.8005 16.8562Z"
          fill="#1E293B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1391_10476">
          <rect x="0.861572" width="36" height="36" rx="8.61539" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
